var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "600" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: {
          title: "Move Data Source",
          shouldClose: !_vm.assignOptions.isTestRun,
        },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { dark: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [_vm._v("Move Data Source")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c("v-text-field", {
                    attrs: { label: "Source Name", disabled: "" },
                    model: {
                      value: _vm.formObject.LocationIdentifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "LocationIdentifier", $$v)
                      },
                      expression: "formObject.LocationIdentifier",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    attrs: {
                      label: "Assigned Location",
                      items: _vm.monitoringFeatures,
                      "item-value": "Id",
                      "item-text": "DisplayName",
                    },
                    model: {
                      value: _vm.formObject.MonitoringFeatureId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "MonitoringFeatureId", $$v)
                      },
                      expression: "formObject.MonitoringFeatureId",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "mt-0",
                    attrs: {
                      color: "error",
                      label: "Test Run",
                      "persistent-hint": "",
                      hint: "See logs of the outcome without making any changes",
                    },
                    model: {
                      value: _vm.assignOptions.isTestRun,
                      callback: function ($$v) {
                        _vm.$set(_vm.assignOptions, "isTestRun", $$v)
                      },
                      expression: "assignOptions.isTestRun",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "mt-",
                    attrs: {
                      color: "info",
                      label: "Move primary alias",
                      "persistent-hint": "",
                      hint: "Non-primary aliases are always moved. Should the primary alias move too?",
                    },
                    model: {
                      value: _vm.assignOptions.shouldMovePrimaryAlias,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.assignOptions,
                          "shouldMovePrimaryAlias",
                          $$v
                        )
                      },
                      expression: "assignOptions.shouldMovePrimaryAlias",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "mt-",
                    attrs: {
                      color: "info",
                      label: "Can compromise",
                      "persistent-hint": "",
                      hint: "If the primary alias cannot be moved, or the data sources cannot be merged, a compromise will be attempted. Do a test run to verify that the outcome is as expected.",
                    },
                    model: {
                      value: _vm.assignOptions.canCompromise,
                      callback: function ($$v) {
                        _vm.$set(_vm.assignOptions, "canCompromise", $$v)
                      },
                      expression: "assignOptions.canCompromise",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _vm.formObject.MonitoringFeatureId != null
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "warning", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.unlink()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-link-off"),
                      ]),
                      _vm._v("\n        Unlink\n      "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("done")]),
                  _vm._v("\n        Save\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "", disabled: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }